(() => {
/**
 * Marquee
 *
 * @param {HTMLElement} element - The marquee HTML element with only one direct child
 * @param {Number} [speed=undefined] - Speed in pixeles / second
 */ class $099c717928f0c4c1$export$2e2bcd8739ae039 {
    constructor(element, speed){
        this.element = element;
        this.elementClone = element.cloneNode(true);
        this.content = element.firstElementChild;
        this.allContent = [
            this.content
        ];
        this.elementWidth = this.element.getBoundingClientRect().width;
        this.contentWidth = this.content.getBoundingClientRect().width;
        this.speed = speed ? speed : 10;
        this.validate() && this.init();
    }
    validate() {
        if (this.element.children.length > 1) {
            console.error("Marquee element must have only ONE direct children");
            return false;
        }
        return true;
    }
    init() {
        for(let index = 0; index < Math.ceil(this.elementWidth / this.contentWidth); index++){
            const clone = this.content.cloneNode(true);
            clone.ariaHidden = true;
            this.allContent.push(clone);
            this.element.appendChild(clone);
        }
        this.setAnimationDuration();
        this.eventListenerResize();
        this.animate();
    }
    animate() {
        this.content.animate([
            {
                marginLeft: "0"
            },
            {
                marginLeft: `-${this.contentWidth}px`
            }
        ], {
            duration: this.animationDuration,
            iterations: Infinity,
            easing: "linear"
        });
    }
    setAnimationDuration() {
        const speedPerPx = this.contentWidth / this.speed;
        this.animationDuration = speedPerPx * 100;
    // console.log(this.animationDuration);
    }
    eventListenerResize() {
        window.addEventListener("resize", ()=>this.reset());
    }
    reset() {
        this.element.after(this.elementClone);
        this.element.remove();
        return new $099c717928f0c4c1$export$2e2bcd8739ae039(this.elementClone, this.speed);
    }
    setSpeed(speed) {
        this.speed = speed;
        this.setAnimationDuration();
    }
    pause() {
        this.allContent.forEach((item)=>item.style.animationPlayState = "paused");
    }
    play() {
        this.allContent.forEach((item)=>item.style.animationPlayState = "running");
    }
}


document.addEventListener("DOMContentLoaded", ()=>{
    const marquees = document.querySelectorAll(".fcb-marquee");
    marquees.forEach((marquee)=>{
        const speed = parseInt(marquee.dataset.speed);
        new (0, $099c717928f0c4c1$export$2e2bcd8739ae039)(marquee, speed);
    });
});

})();
//# sourceMappingURL=section-marquee.js.map
